import { text } from '@/theme/colors/palettes';
import { TEAM_CONCERNS_RANGES, TTeamConcernsRange } from '@/types/Organization.types';
import { Select } from '@chakra-ui/react';
import { RANGE_DISPLAY_LABELS } from './helpers';

interface Props {
  range: TTeamConcernsRange;
  onChange: (range: TTeamConcernsRange) => void;
}

const TeamConcernsRangeSelect = ({ range, onChange }: Props) => (
  <Select
    size={'sm'}
    value={range}
    width={'120px'}
    variant={'unstyled'}
    color={text.mediumBlue}
    fontWeight={700}
    onChange={(e) => onChange(e.target.value as TTeamConcernsRange)}
  >
    {TEAM_CONCERNS_RANGES.map((r) => (
      <option key={r} value={r}>
        {RANGE_DISPLAY_LABELS[r]}
      </option>
    ))}
  </Select>
);

export default TeamConcernsRangeSelect;
